import React, { useEffect, useState } from 'react';
import {BrowserRouter, Switch, Route} from 'react-router-dom'
import Axios from 'axios'

import "./App.css"
import "./styling/navbar.css"
import "./styling/loginpage.css"

import Homepage from './routes/home'
import LoginPage from './routes/loginpage'
import Profile from './routes/profile'
import PageNotFound from './routes/pagenotfound'

import {useSubscribe} from './useSubscribe'

function App() {
    const [loginDetail, setLoginDetail] = useState('')
    const [responseStatus, setResponseStatus] = useState(false)
    Axios.defaults.withCredentials = true
    const { setSubscription } = useSubscribe({publicKey: "BMul4r89zMDkkdEjH8JEQYZmvOWbqjgMATBqLO_vPGOj6T_qkOWW3FIhiYgNsmGealGb_eSePF6_HcPZu1-cl-c"});


    useEffect(() => {
        async function checkLoggedIn() {
            const response = await Axios.get("/api/loggedin")
            if (response.data.LoggedIn) {
                setLoginDetail(response.data.user)
            }

            setSubscription(response.data.LoggedIn)

            setTimeout(()=>{
                setResponseStatus(true)
            }, 500)
        }
    checkLoggedIn();
    }, [])
    if (!responseStatus) {
        return (
            <div>
                <div className="loader-wrapper">
                    <div className="loader"></div>
                </div>
            </div>
        )
    }
    return (
        <div>
            <BrowserRouter>
                <Switch>
                    <Route path="/" component={() => (<Homepage loginDetail={loginDetail} />)} exact />
                    <Route path="/authenticate" component={() => (<LoginPage loginDetail={loginDetail} />)} exact />
                    <Route path="/u/*/*" component={PageNotFound} />
                    <Route path="/u/*" component={() => (<Profile loginDetail={loginDetail} setLoginDetail={setLoginDetail} responseStatus = {responseStatus} />)} exact />
                    <Route component={PageNotFound} />
                </Switch>
            </BrowserRouter>


        </div>
    );
}

export default App